import { useSearchMyTasksQuery } from '@exam-management/graphql';
import { Pagination } from '@shared/components';

import { useMyTaskSearchParams } from '../../hooks';
import {
  CARD_LIST_PAGE_SIZE,
  ORDER_FIELD_BY_STATUS,
  ORDER_TYPE_BY_STATUS,
} from '../my-task-card-list/constants';

export default function MyTaskPagination() {
  const [{ status, page }, { changePage }] = useMyTaskSearchParams();

  const { data: searchMyTasksData, loading: isLoading } = useSearchMyTasksQuery({
    variables: {
      searchMyTasksInput: {
        filter: { status },
        order: {
          field: ORDER_FIELD_BY_STATUS[status],
          type: ORDER_TYPE_BY_STATUS[status],
        },
        paging: {
          currentPage: page,
          pageSize: CARD_LIST_PAGE_SIZE,
        },
      },
    },
    fetchPolicy: 'cache-first',
  });

  const total = searchMyTasksData?.wflSearchMyTasks.total ?? 0;

  const handlePageChange = (newPage: number) => {
    changePage(newPage);
  };

  const hidePagination = !isLoading && total <= CARD_LIST_PAGE_SIZE;

  return (
    <Pagination
      count={Math.ceil(total / CARD_LIST_PAGE_SIZE)}
      page={page + 1}
      onChange={(_, newPage) => handlePageChange(newPage - 1)}
      hidden={hidePagination}
    />
  );
}
